import {useRef} from 'react'
import {usePopup} from '#/contexts/analyzeTextContext'
import {StyleSheet, TouchableOpacity, View} from 'react-native'
import BottomSheet, {BottomSheetView} from '@gorhom/bottom-sheet'
import {Text} from '#/view/com/util/text/Text'
import {GestureHandlerRootView} from 'react-native-gesture-handler'
import {RemoveScroll} from 'react-remove-scroll'
import {RATING} from './consts'
import {getRatingIndex} from './utils'
import {Dimensions} from 'react-native'

const RewritePopup = () => {
  const bottomSheetRef = useRef<BottomSheet>(null)

  const {isOpen, closePopup, onYesCallback, onNoCallback, score} = usePopup()

  if (!isOpen) return null

  const handleYes = () => {
    if (onYesCallback) {
      onYesCallback()
    }
    closePopup()
  }

  const handleNo = () => {
    if (onNoCallback) {
      onNoCallback()
    }
    closePopup()
  }

  const currentScore = RATING[getRatingIndex(score)]
  const ScoreIcon = currentScore.icon

  const windowWidth = Dimensions.get('window').width
  const popupWidth = 598

  return (
    <GestureHandlerRootView style={styles.container}>
      <BottomSheet
        ref={bottomSheetRef}
        style={{
          ...styles.bottomSheet,
          marginLeft:
            windowWidth > popupWidth ? (windowWidth - popupWidth) / 2 : 0,
        }}>
        <BottomSheetView style={styles.contentContainer}>
          <RemoveScroll style={styles.contentScroll}>
            <Text style={styles.title}>
              Use AI to edit your post to get more civil responses
            </Text>
            <View style={styles.logoContainer}>
              <ScoreIcon size={108} />
              <Text style={styles.logoText}>{currentScore.title}</Text>
            </View>
            <Text style={styles.description}>
              We're asking people to rewrite posts with potentially harmful or
              offensive language
            </Text>
            <View>
              <TouchableOpacity
                style={styles.primaryButton}
                onPress={handleYes}>
                <Text style={styles.primaryButtonText}>Rewrite using AI</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={styles.secondaryButton}
                onPress={handleNo}>
                <Text style={styles.secondaryButtonText}>
                  Post without rewriting
                </Text>
              </TouchableOpacity>
            </View>
          </RemoveScroll>
        </BottomSheetView>
      </BottomSheet>
    </GestureHandlerRootView>
  )
}

export default RewritePopup

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  bottomSheet: {
    maxWidth: 598,
    width: '100%',
  },
  bottomSheetContainer: {
    color: 'red',
  },
  contentContainer: {
    flex: 1,
    padding: 24,
    alignItems: 'center',
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  description: {
    fontSize: 16,
    textAlign: 'center',
    color: '#333',
  },
  logoText: {
    fontSize: 16,
    textAlign: 'center',
    color: '#333',
    fontWeight: 'bold',
  },
  contentScroll: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 20,
  },
  primaryButton: {
    backgroundColor: '#2463EB',
    padding: 16,
    borderRadius: 12,
    alignItems: 'center',
  },
  primaryButtonText: {
    color: 'white',
    fontSize: 16,
    fontWeight: 'bold',
  },
  secondaryButton: {
    padding: 16,
    alignItems: 'center',
  },
  secondaryButtonText: {
    color: '#333',
    fontSize: 16,
    fontWeight: 'bold',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
})
